"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoginPanel_1 = require("./LoginPanel");
exports.default = LoginPanel_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/LoginPanel/index.js
// module id = 801
// module chunks = 8